import { palette } from "./index";

export const muiColorTokens = {
  palette: {
    primary: {
      main: palette.primary,
      dark: palette.primaryHover,
      light: palette.primaryLight,
      contrastText: palette.textInverse,
    },
    secondary: {
      main: palette.accent,
    },
    background: {
      default: palette.surfacePage,
      paper: palette.surface,
    },
    text: {
      primary: palette.textPrimary,
      secondary: palette.textSecondary,
    },
    divider: palette.border,
    success: {
      main: palette.success,
    },
    error: {
      main: palette.danger,
    },
    warning: {
      main: palette.warning,
    },
  },
  typography: {
    fontFamily: "var(--font-body)",
  },
};

export default muiColorTokens;
